import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Ao trocar de página, volta ao topo (ou rola até a âncora, se houver #). */
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }
        // pulo instantâneo (sem a rolagem suave do CSS) para a nova página já abrir no topo
        const html = document.documentElement;
        const prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, 0);
        html.style.scrollBehavior = prev;
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
